
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'rui-checkbox',
  props: {
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
